import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { MessageService } from '../shared/components/message.service';

@Injectable({ providedIn: 'root' })
export class SupportedLanguagesService {
  private readonly url = environment.apiConfig.uri + 'api/languages';
  private languages$: Observable<string[]> | null = null;

  constructor(
    private http: HttpClient,
    private messageService: MessageService,
  ) {}

  getSupportedLanguages(): Observable<string[]> {
    if (!this.languages$) {
      this.languages$ = this.http.get<string[]>(this.url).pipe(
        catchError((err: unknown) => {
          this.languages$ = null;
          if (!(err instanceof HttpErrorResponse && err.status === 401)) {
            this.messageService.error('personalData.error.languagesLoadFailed');
          }
          return throwError(() => err);
        }),
        shareReplay(1),
      );
    }
    return this.languages$;
  }
}
